import React from 'react';
import { Box } from '@mui/material';

/**
 * Web FormRow ile aynı: 2 veya 3 kolon grid (mobilde tek kolon).
 * children: React element(s)
 */
const InputRow = ({ children, columns = 2, mt = 0 }) => {
  const items = React.Children.toArray(children).filter(Boolean);
  const cols =
    columns === 3 ? { xs: '1fr', sm: '1fr 1fr', md: '1fr 1fr 1fr' } : { xs: '1fr', sm: '1fr 1fr' };

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: cols,
        gap: 2,
        width: '100%',
        mt,
        mb: 0.5,
        alignItems: 'start',
        '& > *': {
          minWidth: 0,
          width: '100%',
        },
      }}
    >
      {items.map((child, index) => (
        <Box key={child.key || index} sx={{ width: '100%', minWidth: 0 }}>
          {child}
        </Box>
      ))}
    </Box>
  );
};

export default InputRow;
